import React, { useState, PropsWithChildren, Fragment, ReactNode } from 'react';
import { infoboxIconActStyle, infoboxIconStyle, ScrollToElem } from '../SubpageComponents';
import { RiskVariant, Insured } from '../../model/policy/AccidentPolicy';
import { Button } from 'react-bootstrap';
import { InfoboxIcon } from '../svg/Icons';
import { risksTable, premiumsSports, premiumsExtremeSports } from './VariantsTable';

export function VariantsTableMobile(props: {
  onChange?: () => void,
  insured: Insured | undefined
})
{
  const [showVariant, setShowVariant] = useState(props.insured?.variant.getValue());

  function choiceRows()
  {
    return (
      <>

        <SelectableRow
          className="bg-blue"
          rowNo={risksTable.length}
          skipStripping={true}
          renderCells={isSelected =>
            <>
              <td colSpan={3} className={`text-center${!isSelected ? ' cursor-pointer' : ''}`}>
                <strong>
                  Składka roczna za osobę z rozszerzeniem o wyczynowe uprawianie sportu
                </strong>
                <InfoboxIcon className="ml-2" style={infoboxIconStyle} />
              </td>
            </>}
          expandedRow={<>
            <tr className={(risksTable.length + 1) % 2 === 0 ? 'even' : 'odd'}>
              <td colSpan={3} className="text-left">
                <div className="text-justify">
                  Wyczynowe uprawianie sportu – forma aktywności fizycznej podejmowana w celu uzyskania, w drodze indywidualnej lub zbiorowej rywalizacji, maksymalnych wyników sportowych, polegająca na uprawianiu przez Ubezpieczonego sportu:
                </div>
                <div className="mt-3 ml-2 text-justify">
                  a) poprzez uczestniczenie w treningach, zawodach, zgrupowaniach i obozach kondycyjnych lub szkoleniowych w ramach pozaszkolnych klubów, związków i organizacji sportowych,
                </div>
                <div className="mt-2 ml-2 text-justify">
                  b) podczas zajęć wychowania fizycznego odbywających się w ramach obowiązującego planu lekcji w szkołach sportowych.
                </div>
              </td>
            </tr>
          </>}
        />
        <tr>
          <td className="text-center amount">
            <strong>{premiumsSports[0]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant1} extremeSports={false} {...props} />
          </td>
          <td className="text-center amount">
            <strong>{premiumsSports[1]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant2} extremeSports={false} {...props} />
          </td>
          <td className="text-center amount">
            <strong>{premiumsSports[2]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant3} extremeSports={false} {...props} />
          </td>
        </tr>

        <SelectableRow
          className="bg-blue"
          rowNo={risksTable.length + 1}
          skipStripping={true}
          renderCells={isSelected =>
            <>
              <td colSpan={3} className={`text-center${!isSelected ? ' cursor-pointer' : ''}`}>
                <strong>
                  Składka roczna za osobę z rozszerzeniem o sporty i aktywności wysokiego ryzyka
                </strong>
                <InfoboxIcon className="ml-2" style={infoboxIconStyle} />
              </td>
            </>}
          expandedRow={<>
            <tr className={(risksTable.length + 1) % 2 === 0 ? 'even' : 'odd'}>
              <td colSpan={3} className="text-left">
                <div className="fw-600">
                  Sporty i aktywności wysokiego ryzyka włączone do ochrony ubezpieczeniowej
                </div>
                <div className="mt-3">
                  Za zapłatą dodatkowej składki, zakres ubezpieczenia Ubezpieczonego może zostać rozszerzony na warunkach określonych w OWU o następstwa nieszczęśliwych wypadków doznane w związku z uprawianiem następujących sportów i aktywności wysokiego ryzyka: airsoft, taternictwo, trekking, nurkowanie ze sprzętem do głębokości 30 metrów poniżej poziomu morza, windsurfing, żegluga poza wodami terytorialnymi w odległości powyżej 12 mil morskich od brzegu, jazda na nartach wodnych, kitesurfing, kolarstwo górskie, jeździectwo, zorbing, strzelectwo sportowe.
                </div>
                <div className="fw-600 mt-4">
                  Sporty i aktywności wysokiego ryzyka wyłączone z ochrony ubezpieczeniowej
                </div>
                <div className="mt-3">
                  highlining, slacklining, bouldering, wspinaczka skalna, wspinaczka lodowa, alpinizm, himalaizm, skialpinizm, zjazdy ekstremalne na nartach, freestyle, freeride, snowboarding wysokogórski, snowboarding prędkościowy, skoki i ewolucje narciarskie i snowboardowe, rafting, canyoning, hydrospeed, kajakarstwo górskie, szybownictwo, spadochroniarstwo, lotniarstwo, paralotniarstwo, motolotniarstwo, baloniarstwo, pilotowanie samolotów lub śmigłowców, skoki z/na bungee, nurkowanie powyżej głębokości 30m, parkour, freerun, buggykitting, jazda quadami, speedrower, kolarstwo ekstremalne, speleologia, bobsleje, saneczkarstwo, sporty motorowe, rajdy pojazdów lądowych, wodnych lub powietrznych, heliskiing, heliboarding, freefall, downhill, b.a.s.e. jumping, dream jumping oraz zjazdy na nartach lub snowboardzie poza wyznaczonymi trasami, skeleton, bojery, jazda skibobem oraz sporty, w których wykorzystywane są pojazdy przeznaczone do poruszania się po śniegu lub lodzie.
                </div>
              </td>
            </tr>
          </>}
        />

        <tr>
          <td className="text-center amount">
            <strong>{premiumsExtremeSports[0]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant1} extremeSports={true} {...props} />
          </td>
          <td className="text-center amount">
            <strong>{premiumsExtremeSports[1]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant2} extremeSports={true} {...props} />
          </td>
          <td className="text-center amount">
            <strong>{premiumsExtremeSports[2]} PLN</strong>
            <br />
            <VariantButton variant={RiskVariant.Variant3} extremeSports={true} {...props} />
          </td>
        </tr>
      </>
    );
  }

  const zwinZakres =
    <Button
      id="varHide"
      variant="primary"
      onClick={() =>
      {
        setShowVariant(undefined);
      }}
    >
      Zwiń<br />zakres
    </Button>;

  return <>
    <div className={`tableBox mt-4 stdColors only-mobile`}>
      <table className={`w-100 mb-3`}>
        <thead>
          <tr>
            <th
              className="text-nowrap"
              style={{
                borderLeftColor: 'var(--blue-color)',
                borderTop: 'none'
              }}
            >
              Wariant I
            </th>
            <th
              className="text-nowrap"
              style={{ borderTop: 'none' }}
            >
              Wariant II
            </th>
            <th
              className="text-nowrap"
              style={{
                borderRightColor: 'var(--blue-color)',
                borderTop: 'none'
              }}
            >
              Wariant III
            </th>
          </tr>
          {choiceRows()}
          <tr>
            <th
              className="text-nowrap"
              style={{
                borderLeftColor: 'var(--blue-color)',
                borderTop: 'none',
                borderBottom: (showVariant === RiskVariant.Variant1) ? 'none' : undefined
              }}
            >
              {(showVariant === RiskVariant.Variant1) ? zwinZakres :
                <Button
                  id="varShow1"
                  variant="primary"
                  onClick={() =>
                  {
                    setShowVariant(RiskVariant.Variant1);
                  }}
                >
                  Zobacz<br />zakres
                </Button>}
            </th>
            <th className="text-nowrap" style={{
              borderTop: 'none',
              borderBottom: (showVariant === RiskVariant.Variant2) ? 'none' : undefined
            }}>
              {(showVariant === RiskVariant.Variant2) ? zwinZakres :
                <Button
                  id="varShow2"
                  variant="primary"
                  onClick={() =>
                  {
                    setShowVariant(RiskVariant.Variant2);
                  }}
                >
                  Zobacz<br />zakres
                </Button>}
            </th>
            <th
              className="text-nowrap"
              style={{
                borderRightColor: 'var(--blue-color)',
                borderTop: 'none',
                borderBottom: (showVariant === RiskVariant.Variant3) ? 'none' : undefined
              }}
            >
              {(showVariant === RiskVariant.Variant3) ? zwinZakres :
                <Button
                  id="varShow3"
                  variant="primary"
                  onClick={() =>
                  {
                    setShowVariant(RiskVariant.Variant3);
                  }}
                >
                  Zobacz<br />zakres
                </Button>}
            </th>
          </tr>
          {(showVariant) && <>
            <tr>
              <th
                colSpan={3}
                style={{
                  borderTopColor: 'var(--blue-color)',
                  borderLeftColor: 'var(--blue-color)',
                  borderRightColor: 'var(--blue-color)',
                }}
              >
                Rodzaj świadczenia
              </th>
            </tr>
            <tr>
              <th
                colSpan={3}
                style={{
                  borderLeftColor: 'var(--blue-color)',
                  borderRightColor: 'var(--blue-color)',
                  borderBottom: 'none'
                }}
              >
                Wysokość świadczenia (PLN)
              </th>
            </tr>
          </>}
        </thead>
        <tbody>
          {(showVariant) && <>
            {risksTable.map((risk, idx) =>
            {
              return (
                <Fragment key={idx}>
                  <SelectableRow
                    rowNo={idx}
                    renderCells={isSelected => <>
                      <td colSpan={3} className={`text-left kind${risk.description && !isSelected ? ' cursor-pointer' : ''}`}>
                        {risk.name}
                        {risk.description &&
                          <InfoboxIcon className="ml-2" style={isSelected ? infoboxIconActStyle : infoboxIconStyle} />
                        }
                      </td>
                    </>
                    }
                    expandedRow={
                      <>
                        {risk.description &&
                          <tr className={idx % 2 === 0 ? 'even' : 'odd'}>
                            <td colSpan={4} className="text-left">
                              {risk.description}
                            </td>
                          </tr>}
                      </>}
                  />
                  <tr className={idx % 2 === 0 ? 'even' : 'odd'}>
                    <td colSpan={3} className="text-right amount">
                      {(showVariant === RiskVariant.Variant1) && risk.variant1}
                      {(showVariant === RiskVariant.Variant2) && risk.variant2}
                      {(showVariant === RiskVariant.Variant3) && risk.variant3}
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </>}
        </tbody>
      </table>
    </div>
  </>;
}

function SelectableRow(props: PropsWithChildren<
  {
    className?: string;
    rowNo: number,
    renderCells: (isSelected: boolean) => ReactNode,
    expandedRow?: ReactNode,
    scrollToExpRow?: boolean;
    exRef?: any,
    skipStripping?: boolean;
  }
>)
{
  const [isSelected, setSelected] = useState(false);
  const classes: string[] = [];
  if (!props.skipStripping)
  {
    classes.push(props.rowNo % 2 === 0 ? 'even' : 'odd');
  }
  if (props.className)
  {
    classes.push(props.className);
  }


  return (
    <>
      <tr
        ref={props.exRef}
        id={`expRow${props.rowNo}`}
        onClick={() =>
        {
          setSelected(!isSelected);
          if (!isSelected)
          {
            ScrollToElem(`expRow${props.rowNo}`, 'center');
          }
        }}
        className={classes.join(' ')}
      >{
          props.renderCells(isSelected)
        }
      </tr>
      {isSelected && props.expandedRow}
    </>);
}

function VariantButton(props:
  {
    insured?: Insured,
    variant: RiskVariant,
    extremeSports: boolean,
    onChange?: (variant: RiskVariant) => void,
  })
{
  return (
    <>
      <Button
        id={'var' + props.variant + 'ex' + (props.extremeSports ? 'Yes' : 'No')}
        variant="primary"
        className="mt-3"
        onClick={() =>
        {
          props.insured?.variant.setValue(props.variant);
          props.insured?.extremeSports.setValue(props.extremeSports);
          props.insured?.calculatePremium();
          if (props.onChange)
          {
            props.onChange(props.variant);
          }
        }}
      >
        Wybieram
      </Button>
    </>
  );
}
